module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "tx21"
  }, [_c('p', {
    staticClass: "jtp1",
    attrs: {
      "id": "d41151231"
    }
  }, [_c('b', [_vm._v(" Also by Iain Levison ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx10"
  }, [_c('p', {
    staticClass: "jtp1",
    attrs: {
      "id": "d41151261"
    }
  }, [_c('i', [_vm._v(" A Working Stiff's Manifesto")])]), _vm._v(" "), _c('p', {
    staticClass: "jtp1",
    attrs: {
      "id": "d41151262"
    }
  }, [_c('i'), _c('i', [_vm._v("Since the Layoffs ")])]), _vm._v(" "), _c('p', {
    staticClass: "jtp1",
    attrs: {
      "id": "d41151263"
    }
  }, [_c('i', [_vm._v(" Dog Eats Dog ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cdf21c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap2a_howtorob_9781569477113_epub_part2a.vue
// module id = 63
// module chunks = 0